import ProductColorPicker from './ProductColorPicker'

export default ProductColorPicker
